import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-279a3215"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "titleRow" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "numbox" }
const _hoisted_5 = { class: "left box" }
const _hoisted_6 = { class: "n" }
const _hoisted_7 = { class: "s" }
const _hoisted_8 = { class: "t" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Dirver" }, null, -1 /* HOISTED */))
const _hoisted_10 = { class: "center box" }
const _hoisted_11 = { class: "n" }
const _hoisted_12 = { class: "s" }
const _hoisted_13 = { class: "t" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Dirver" }, null, -1 /* HOISTED */))
const _hoisted_15 = { class: "right box" }
const _hoisted_16 = { class: "n" }
const _hoisted_17 = { class: "s" }
const _hoisted_18 = { class: "t" }
const _hoisted_19 = { class: "rqrow" }
const _hoisted_20 = { style: {"width":"20%"} }
const _hoisted_21 = { style: {"width":"40%","text-align":"center"} }
const _hoisted_22 = { style: {"width":"25%","text-align":"center"} }
const _hoisted_23 = { style: {"width":"15%","text-align":"center"} }
const _hoisted_24 = { class: "rlist" }
const _hoisted_25 = { class: "saishi" }
const _hoisted_26 = { class: "left" }
const _hoisted_27 = { class: "cenbox" }
const _hoisted_28 = { style: {"width":"20%","text-align":"center","margin":"0 10px","color":"#1692E1"} }
const _hoisted_29 = { class: "right" }
const _hoisted_30 = { style: {"width":"50%"} }
const _hoisted_31 = { style: {"margin-bottom":"5px"} }
const _hoisted_32 = { style: {"margin-left":"10px","width":"50%"} }
const _hoisted_33 = { style: {"margin-bottom":"5px"} }
const _hoisted_34 = { class: "titleRow" }
const _hoisted_35 = { class: "left" }
const _hoisted_36 = { class: "right" }
const _hoisted_37 = {
  class: "details-tab flexcenter",
  style: {"margin-top":"20px","margin-bottom":"30px"}
}
const _hoisted_38 = { class: "rqrow" }
const _hoisted_39 = { style: {"width":"20%"} }
const _hoisted_40 = { style: {"width":"40%","text-align":"center"} }
const _hoisted_41 = { style: {"width":"25%","text-align":"center"} }
const _hoisted_42 = { style: {"width":"15%","text-align":"center"} }
const _hoisted_43 = { class: "rlist" }
const _hoisted_44 = { class: "saishi" }
const _hoisted_45 = { class: "left" }
const _hoisted_46 = { class: "cenbox" }
const _hoisted_47 = { style: {"width":"20%","text-align":"center","margin":"0 10px","color":"#1692E1"} }
const _hoisted_48 = { class: "right" }
const _hoisted_49 = { style: {"width":"50%"} }
const _hoisted_50 = { style: {"margin-bottom":"5px"} }
const _hoisted_51 = { style: {"margin-left":"10px","width":"50%"} }
const _hoisted_52 = { style: {"margin-bottom":"5px"} }
const _hoisted_53 = { class: "rlist" }
const _hoisted_54 = { class: "saishi" }
const _hoisted_55 = { class: "left" }
const _hoisted_56 = { class: "cenbox" }
const _hoisted_57 = { style: {"width":"20%","text-align":"center","margin":"0 10px","color":"#1692E1"} }
const _hoisted_58 = { class: "right" }
const _hoisted_59 = { style: {"width":"50%"} }
const _hoisted_60 = { style: {"margin-bottom":"5px"} }
const _hoisted_61 = { style: {"margin-left":"10px","width":"50%"} }
const _hoisted_62 = { style: {"margin-bottom":"5px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_divider = _resolveComponent("van-divider")!

  return ($setup.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('play.lsjz')), 1 /* TEXT */),
          _createElementVNode("div", {
            class: "right",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup._onRecentHomeSide())),
            style: _normalizeStyle({ 'color': $setup.recentHomeSide ? '#1692E1' : '#878787', })
          }, _toDisplayString(_ctx.$t('match.tzk')), 5 /* TEXT, STYLE */)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString($setup.analysis.winLv), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('play.sv')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_8, _toDisplayString($setup.analysis.win + _ctx.$t('play.win')) + " " + _toDisplayString($setup.analysis.draw + _ctx.$t('play.draw')) + _toDisplayString($setup.analysis.fail
                    + _ctx.$t('play.owe')), 1 /* TEXT */)
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString($setup.analysis.asiaLv), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('play.ypl')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.analysis.asiaWin + _ctx.$t('play.win')) + _toDisplayString($setup.analysis.asiaFail) + " " + _toDisplayString(_ctx.$t('play.shu')) + " " + _toDisplayString($setup.analysis.asiaDraw) + " " + _toDisplayString(_ctx.$t('play.zou')), 1 /* TEXT */)
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString($setup.analysis.dxLv), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('play.dql')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_18, _toDisplayString($setup.analysis.da) + " " + _toDisplayString(_ctx.$t('play.da')) + " " + _toDisplayString($setup.analysis.xiao) + " " + _toDisplayString(_ctx.$t('play.xiao')) + " " + _toDisplayString($setup.analysis.zou) + " " + _toDisplayString(_ctx.$t('play.zou')), 1 /* TEXT */)
          ])
        ]),
        _createVNode(_component_van_divider),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('play.rqss')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('play.dz')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('play.rq')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('play.dx')), 1 /* TEXT */)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.historyData, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createCommentVNode(" <div style=\"width: 20%;color: #878787;\">{{formatDateTime(item.time,\"YYYY-MM-DD\")}}</div> "),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", null, _toDisplayString($setup.formatDateTime(item.time, "YYYY-MM-DD")), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(item.league), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  style: _normalizeStyle({ 'width': '40%', 'text-align': 'right', 'color': $setup.getname(item).homecolor })
                }, _toDisplayString(item.homeName), 5 /* TEXT, STYLE */),
                _createElementVNode("div", _hoisted_28, _toDisplayString(item.homeScore + ':' +
                        item.awayScore), 1 /* TEXT */),
                _createElementVNode("div", {
                  style: _normalizeStyle({ 'width': '40%', 'text-align': 'left', 'color': $setup.getname(item).awaycolor })
                }, _toDisplayString(item.awayName), 5 /* TEXT, STYLE */)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(item.asiaString), 1 /* TEXT */),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ 'color': item.asiaResult > 0 ? '#FC2E34' : '#1692E1' })
                  }, _toDisplayString(item.asiaResult == 0 ?
                            $setup.t('play.zou')
                            : (item.asiaResult > 0 ? $setup.t('play.ying') : $setup.t('play.shu'))), 5 /* TEXT, STYLE */)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(item.daxiaoString), 1 /* TEXT */),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ 'color': item.daxiaoResult > 0 ? '#FC2E34' : '#1692E1' })
                  }, _toDisplayString(item.daxiaoResult > 0 ?
                            $setup.t('play.da') : (item.daxiaoResult == 0 ? $setup.t('play.zou') : $setup.t('play.xiao'))), 5 /* TEXT, STYLE */)
                ])
              ])
            ]),
            _createVNode(_component_van_divider, { style: {"height":"5px","margin":"2px 0"} })
          ]))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('play.jqzt')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onrecentSameSide())),
              style: _normalizeStyle({ 'color': $setup.recentHomeSide ? '#1692E1' : '#878787', })
            }, _toDisplayString(_ctx.$t('match.tzk')), 5 /* TEXT, STYLE */),
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onrecentSameSide())),
              style: _normalizeStyle({ 'color': $setup.recentHomeSide ? '#878787' : '#1692E1', marginLeft: '10px' })
            }, _toDisplayString(_ctx.$t('play.tss')), 5 /* TEXT, STYLE */)
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeType(0))),
              style: _normalizeStyle({
                    color: $setup.selType == 0 ? '#fff' : $setup.primaryColor,
                    'background-color': $setup.selType == 0 ? $setup.primaryColor : '#fff',
                })
            }, _toDisplayString($setup.homeName), 5 /* TEXT, STYLE */),
            _createElementVNode("li", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeType(1))),
              style: _normalizeStyle({
                    color: $setup.selType == 1 ? '#fff' : $setup.primaryColor,
                    'background-color': $setup.selType == 1 ? $setup.primaryColor : '#fff',
                })
            }, _toDisplayString($setup.awayName), 5 /* TEXT, STYLE */)
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('play.rqss')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('play.dz')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('play.rq')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('play.dx')), 1 /* TEXT */)
        ]),
        ($setup.selType == 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.homeList, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createCommentVNode(" <div style=\"width: 20%;color: #878787;\">{{formatDateTime(item.time,\"YYYY-MM-DD\")}}</div> "),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", null, _toDisplayString($setup.formatDateTime(item.time, "YYYY-MM-DD")), 1 /* TEXT */),
                    _createElementVNode("div", null, _toDisplayString(item.league), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", {
                      style: _normalizeStyle({ 'width': '40%', 'text-align': 'right', 'color': $setup.getname(item).homecolor })
                    }, _toDisplayString(item.homeName), 5 /* TEXT, STYLE */),
                    _createElementVNode("div", _hoisted_47, _toDisplayString(item.homeScore + ':' +
                        item.awayScore), 1 /* TEXT */),
                    _createElementVNode("div", {
                      style: _normalizeStyle({ 'width': '40%', 'text-align': 'left', 'color': $setup.getname(item).awaycolor })
                    }, _toDisplayString(item.awayName), 5 /* TEXT, STYLE */)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, _toDisplayString(item.asiaString), 1 /* TEXT */),
                      _createElementVNode("div", {
                        style: _normalizeStyle({ 'color': item.asiaResult > 0 ? '#FC2E34' : '#1692E1' })
                      }, _toDisplayString(item.asiaResult == 0 ?
                            $setup.t('play.zou')
                            : (item.asiaResult > 0 ? $setup.t('play.ying') : $setup.t('play.shu'))), 5 /* TEXT, STYLE */)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, _toDisplayString(item.daxiaoString), 1 /* TEXT */),
                      _createElementVNode("div", {
                        style: _normalizeStyle({ 'color': item.daxiaoResult > 0 ? '#FC2E34' : '#1692E1' })
                      }, _toDisplayString(item.daxiaoResult > 0 ?
                            $setup.t('play.da') : (item.daxiaoResult == 0 ? $setup.t('play.zou') : $setup.t('play.xiao'))), 5 /* TEXT, STYLE */)
                    ])
                  ])
                ]),
                _createVNode(_component_van_divider, { style: {"height":"5px","margin":"2px 0"} })
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($setup.selType == 1)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.awayList, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createCommentVNode(" <div style=\"width: 20%;color: #878787;\">{{formatDateTime(item.time,\"YYYY-MM-DD\")}}</div> "),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", null, _toDisplayString($setup.formatDateTime(item.time, "YYYY-MM-DD")), 1 /* TEXT */),
                    _createElementVNode("div", null, _toDisplayString(item.league), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", {
                      style: _normalizeStyle({ 'width': '40%', 'text-align': 'right', 'color': $setup.getname(item).homecolor })
                    }, _toDisplayString(item.homeName), 5 /* TEXT, STYLE */),
                    _createElementVNode("div", _hoisted_57, _toDisplayString(item.homeScore + ':' +
                        item.awayScore), 1 /* TEXT */),
                    _createElementVNode("div", {
                      style: _normalizeStyle({ 'width': '40%', 'text-align': 'left', 'color': $setup.getname(item).awaycolor })
                    }, _toDisplayString(item.awayName), 5 /* TEXT, STYLE */)
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, _toDisplayString(item.asiaString), 1 /* TEXT */),
                      _createElementVNode("div", {
                        style: _normalizeStyle({ 'color': item.asiaResult > 0 ? '#FC2E34' : '#1692E1' })
                      }, _toDisplayString(item.asiaResult == 0 ?
                            _ctx.$t('play.zou')
                            : (item.asiaResult > 0 ? $setup.t('play.ying') : $setup.t('play.shu'))), 5 /* TEXT, STYLE */)
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, _toDisplayString(item.daxiaoString), 1 /* TEXT */),
                      _createElementVNode("div", {
                        style: _normalizeStyle({ 'color': item.daxiaoResult > 0 ? '#FC2E34' : '#1692E1' })
                      }, _toDisplayString(item.daxiaoResult > 0 ?
                            $setup.t('play.da') : (item.daxiaoResult == 0 ? $setup.t('play.zou') : $setup.t('play.xiao'))), 5 /* TEXT, STYLE */)
                    ])
                  ])
                ]),
                _createVNode(_component_van_divider, { style: {"height":"5px","margin":"2px 0"} })
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}